/* eslint-disable @typescript-eslint/no-explicit-any */
import { h } from "vue";
import { Modal, type SpinProps } from "ant-design-vue";

import { useStore } from "@/store";

import { ConfigMutationTypes } from "@/store/modules/config/mutation-types";

import { isObject } from "./hooks/is";
import { logoutButKeep } from "@/enums/NoNeedLoginPageEnum";
import { RouterName } from "@/enums/RouterEnum";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
// import { setIsLogout } from "@/ipc/user";

export function loading() {
  const store = useStore();
  function setLoading(data: SpinProps | boolean = { spinning: true }) {
    let props: SpinProps = {
      spinning: false,
    };
    if (typeof data === "boolean") {
      props.spinning = data;
    } else if (isObject(data)) {
      props = data;
    }
    store.commit(ConfigMutationTypes.SET_SPIN_CONFIG, props);
  }
  window.$loading = setLoading;
}

export function verifyLogin(query: any = {}, router: any) {
  const searchIndex = window.location.href.indexOf("?");
  const returnUrl =
    searchIndex > 0
      ? window.location.href.substring(0, searchIndex)
      : window.location.href;
  const isLogin = localStorage.getItem("isLogin") === "1";
  if (!isLogin) {
    router.push({
      name: RouterName.LOGIN,
      query: { returnUrl, ...query },
    });
    return false;
  }
  return true;
}

const initStyles = () => {
  const styleId = "logout-dialog-styles";
  if (document.getElementById(styleId)) return;

  const style = document.createElement("style");
  style.id = styleId;
  style.textContent = `
    .logout-confirm-dialog .ant-btn {
      font-size: 12px !important;
      height: 30px !important;
    }
  `;
  document.head.appendChild(style);
};

const logoutConfirmDialog = (name: RouterName, router: any) => {
  initStyles();
  Modal.confirm({
    title: "退出登录",
    icon: null,
    class: "logout-confirm-dialog",
    content: h("div", { class: "f-c-s-s w100" }, [
      h("div", { class: "pt-3 pb-12 f-r-s-c" }, [
        h(ExclamationCircleOutlined, { style: { color: "#4749ad" } }),
        h("p", { class: "ml-2" }, "确定退出登录吗？"),
      ]),
    ]),
    okText: "确定",
    cancelText: "取消",
    onOk: () => {
      window.electronAPI.clearToken();
      handleLogout(name, router);
    },
    onCancel: () => {
      Modal.destroyAll();
    },
  });
};

export async function verifyLogout(
  name: RouterName,
  router: any,
  errorFlag?: boolean
) {
  // 如果是手动退出，需要判断是否有任务->询问是否确认关闭
  // 如果是token过期，直接退出
  if (!errorFlag) {
    const IS_ELECTRON = process.env.IS_ELECTRON === "true";
    if (IS_ELECTRON) {
      const shouldClose = await window.electronAPI.logout();
      if (shouldClose) {
        logoutConfirmDialog(name, router);
      }
    } else {
      handleLogout(name, router);
    }
  } else {
    handleLogout(name, router);
  }
}

async function handleLogout(name: RouterName, router: any) {
  const store = useStore() as any;
  console.log(logoutButKeep);
  const shouldGoLogin = !logoutButKeep.includes(name);
  const IS_ELECTRON = process.env.IS_ELECTRON === "true";
  if (IS_ELECTRON) {
    // 退出登录必须“尽最大努力”停掉所有任务；任何一步失败都不能阻止后续清理继续执行。
    // 否则会出现：openId 被清空后，上传/下载仍在 onProgress 回调里写 taskData，导致刷屏与任务继续。
    try {
      // 先停任务（最关键）：避免后续清 token / setUser(null) 后还有 in-flight 更新
      try {
        await window.electronAPI.pauseAllUploadTasks();
      } catch (e) {
        console.error("[logout] pauseAllUploadTasks failed:", e);
      }
      try {
        await window.electronAPI.pauseAllDownloadTasks();
      } catch (e) {
        console.error("[logout] pauseAllDownloadTasks failed:", e);
      }

      // 再清线程池/协议/worker（次关键）：释放资源、避免残留
      try {
        await window.electronAPI.clearUploadThreadPool();
      } catch (e) {
        console.error("[logout] clearUploadThreadPool failed:", e);
      }
      try {
        await window.electronAPI.cleanupUploadProtocols();
      } catch (e) {
        console.error("[logout] cleanupUploadProtocols failed:", e);
      }
      try {
        await window.electronAPI.clearDownloadThreadPool();
      } catch (e) {
        console.error("[logout] clearDownloadThreadPool failed:", e);
      }
      try {
        await window.electronAPI.closeGlobalDownloader();
      } catch (e) {
        console.error("[logout] closeGlobalDownloader failed:", e);
      }
      try {
        await window.electronAPI.stopAllWorkers();
      } catch (e) {
        console.error("[logout] stopAllWorkers failed:", e);
      }
    } finally {
      // 最后无论如何都要把“登出态”与 token/session 清理做完，避免卡在半登出状态
      try {
        await window.electronAPI.setIsLogout(true);
      } catch (e) {
        console.error("[logout] setIsLogout failed:", e);
      }
      try {
        await window.electronAPI.clearSessionId();
      } catch (e) {
        console.error("[logout] clearSessionId failed:", e);
      }
      try {
        await window.electronAPI.clearToken();
      } catch (e) {
        console.error("[logout] clearToken failed:", e);
      }
    }
  } else {
    try {
      await store.dispatch("user/logout");
    } catch (error) {
      log.error("Error stopping workers during logout:", error);
    }
    if (shouldGoLogin) {
      const { LOGIN } = RouterName;
      router.push({ name: LOGIN });
    }
    localStorage.removeItem("chatRoomId");
    return;
  }
  setTimeout(() => {
    store.dispatch("user/logout");
  }, 0);
}
